<template>
  <div id="ccc">
    <div class="h1">
      <div class="w">
        <img src="../../assets/img/pagess/gdd108/022.png" alt="" />
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd108/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h2">
      <div class="relative">
        <img src="../../assets/img/pagess/gdd108/01.png" alt="" />
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd108/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h3">
      <div class="relative">
        <img src="../../assets/img/pagess/gdd108/02.png" alt="" />
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd108/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h4">
      <div class="relative">
        <img src="../../assets/img/pagess/gdd108/03.png" alt="" />
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd108/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h5">
      以上功能均出自股多多软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。股市有风险，投资需谨慎！
    </div>
    <div class="bottomsss">
      <div class="boxx"></div>
      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>
        从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;
        合法机构名单可到中国证监会网站 (<a href="http://www.csrc.gov.cn/"
          >www.csrc.gov.cn</a
        >)查询
      </p>
      <p>
        北京天相财富管理顾问有限公司 &nbsp;&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/">京ICP备16068579号-1</a
        >&nbsp;&nbsp;&nbsp; 执证编号：91110102MA001GJE1N
      </p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>
      <p style="text-decoration: underline; cursor: pointer" class="qwer">
        <span @click="open_yinsi()" style="margin-right: 10px"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <div class="box"></div>
    <div class="fixd">
      <div class="w">
        <img class="img1" src="../../assets/img/pagess/gdd108/f1.png" alt="" />
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd108/btn.png"
          alt=""
        />
        <p>
          以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。股市有风险，投资需谨慎！
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.clientIp();
  },
  methods: {
    to_xaizai() {
      // window.location.href = "https://cdn.juniubang.com/apk/GDD2002.exe";

      this.post_leilei_data();
    },
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },

    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then(res => {});
    },

    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.sourceid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => {  window.open(res.data.message);});
    }
  }
};
</script>
<style lang="less" scoped>
.h1 {
  width: 100%;
  height: 760px;
  background: url(../../assets/img/pagess/gdd108/banner1.jpg) no-repeat center;
  min-width: 1200px;
  position: relative;
  .w {
    width: 1200px;
    margin: 0 auto;

    .btn {
      left: 50%;
      margin-left: 150px;
      top: 491px;
      position: absolute;
    }
  }
}
.h2 {
  width: 100%;
  height: 689px;
  .relative {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .btn {
      position: absolute;
      bottom: 115px;
      margin-left: -500px;
      left: 50%;
    }
  }
}
.h3 {
  width: 100%;
  height: 676px;
  .relative {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .btn {
      position: absolute;

      left: 50%;
      bottom: 120px;
      margin-left: 135px;
    }
  }
}
.h4 {
  width: 100%;
  height: 690px;
  .relative {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .btn {
      position: absolute;
      bottom: 165px;
      margin-left: -480px;
      left: 50%;
    }
  }
}
.h5 {
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.box {
  background-color: black;
  width: 100%;
  height: 200px;
}
.bottomsss {
  width: 100%;
  height: 150px;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: red;
  }
  a {
    font-size: 12px;
    color: #fff;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #fff;
  }
}
.fixd {
  .w {
    p {
      color: #fff;
      font-size: 16px;
      padding-bottom: 20px;
    }
    position: relative;
    width: 1200px;
    margin: 0 auto;
  }
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  .img1 {
    border: 0;
    vertical-align: middle;
    text-align: center;
  }
  .btn {
    position: absolute;
    left: 58%;
    bottom: 40%;
    margin-left: 175px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd137.vue